import Image from 'next/image'
import React, { useState } from 'react'

interface Props {
  images: string[]
  imageAlt?: string
}

const ProductImageSliderMobile: React.FC<Props> = ({ images, imageAlt }) => {
  const [current, setCurrent] = useState(0)

  if (images === undefined || images?.length === 0) {
    return (
      <div className="w-full aspect-square rounded-lg border border-gray-200 bg-gray-50" />
    )
  }

  const handleScroll = (e: React.UIEvent<HTMLDivElement>): void => {
    const index = Math.round(e.currentTarget.scrollLeft / e.currentTarget.clientWidth)
    setCurrent(index)
  }

  return (
    <div className="w-full relative">
      {/* Images */}
      <div
        className="flex overflow-x-auto snap-x snap-mandatory scrollbar-none"
        onScroll={handleScroll}
      >
        {images?.map((src, i) => (
          <div
            key={src}
            className="w-full flex-shrink-0 snap-center"
          >
            <div className="relative w-full aspect-square">
              <Image
                src={src}
                alt={imageAlt ?? 'Product image'}
                fill
                sizes="100vw"
                priority={i === 0}
                fetchPriority={i === 0 ? 'high' : 'auto'}
                className="object-contain"
              />
            </div>
          </div>
        ))}
      </div>

      {/* Dots */}
      {images.length > 1 && (
        <div className="absolute bottom-2 left-0 right-0 flex justify-center space-x-2">
          {images.map((_, i) => (
            <span
              key={i}
              className={[
                'h-2 w-2 rounded-full transition',
                i === current ? 'bg-pink-600' : 'bg-gray-300'
              ].join(' ')}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default ProductImageSliderMobile
